import { useEffect, useState } from "react"
import { Form, Modal } from "antd"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import Notifications from "../../../helpers/Notifications"
import { createAction, getListAction, updateAction } from "./store/actions"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"
import { useDebounce } from "use-debounce"
import CustomSelect from "../../../components/CustomSelect"

    const ReObjectFunctionTypeChangeForm = ({ visible, setVisible, record, setRecord }) => {
    const { isLoading, objectFuncTypes } = useSelector(state => state.reObjectFunctionTypeReducer)
    const {t} = useTranslation(['common', 'valid', 'action'])
	const dispatch = useDispatch()
	const [form] = Form.useForm()

	const [searchParents, setSearchParents] = useState('')
	const [parentValue] = useDebounce(searchParents,500)
	
	useEffect(() => {
		form.resetFields()
		if (record) {
			dispatch(getListAction({name: record.parent?.name}))
			form.setFieldsValue({
				parent : record.parent?.id,
				name   : record.name,
				code1  : record.code1,
				code2  : record.code2,
				code3  : record.code3,
				code4  : record.code4,
			})
		}
	}, [record])

	useEffect(() => {
		dispatch(getListAction({name: parentValue?.trim()}))
	},[parentValue])

	function handleCancel(){
		form.resetFields()
		setRecord(null)
		setVisible(false)
	}

	const save = () => {
		form.validateFields().then(values => {
			const updateValues = {
				id         : record?.id,
				name       : values.name.trim(),
				code1      : values.code1,
				code2      : values.code2,
				code3      : values.code3,
				code4      : values.code4,
				parentId   : values?.parent,
			}
			const previousValues = {
				id         : record?.id,
				name       : record?.name,
				code1      : record?.code1,
				code2      : record?.code2,
				code3      : record?.code3,
				code4      : record?.code4,
				parentId   : record?.parent?.id,
			}
			if (JSON.stringify(updateValues) === JSON.stringify(previousValues))
				Notifications.errorNotice(t('valid:sameData'), null, 20)
			else
				record ? dispatch(updateAction(updateValues)) : dispatch(createAction(updateValues))
		})
	}

	const changeParent = (parentId) => {
		const parent = objectFuncTypes?.find(p => p.id === parentId)

		const fields = {};
		for (const key in parent) {
			if (key.includes("code")) {
				fields[key] = parent[key] !== "00" ? parent[key] : null
			}
		}

		form.setFieldsValue(fields)
	}

	return (
		<Modal
			destroyOnHidden
			footer={[
				<CustomButton
					key="save"
					loading={isLoading}
					type="green"
					onClick={save}
				>
					{t('action:save')}
				</CustomButton>
			]}
			title={record ? t('action:editRecord') : t('action:addRecord')}
			open={visible}
			width={900}
			onCancel={handleCancel}
		>
			<Form
				form={form}
				labelAlign="left"
				labelCol={{span: 6}}
				name="nsi-form"
				wrapperCol={{span: 17, offset: 1}}
			>
				<Form.Item
					label={t('nri:parentReObjFunctionTypes')}
					name="parent"
				> 
					<CustomSelect
						allowClear
						showSearch
						filterOption={false}
						notFoundContent={null}
						options={
							objectFuncTypes?.map(item => ({
									value: item.id,
									label: `${item?.code1}-${item?.code2}-${item?.code3}-${item?.code4} ${item?.name}`
								})
							)
						}
						placeholder={`${t('action:choose')} ${t('nri:parentReObjFunctionTypes').toLowerCase()}`}
						onSearch={(e) => setSearchParents(e)}
						onChange={changeParent}
					/>
				</Form.Item>
				<Form.Item
					label={`1 ${t("common:level").toLowerCase()}`}
					name="code1"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^\d{1,2}$/
						}
					]}
				>
					<CustomInput
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={`2 ${t("common:level").toLowerCase()}`}
					name="code2"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^\d{1,2}$/
						}
					]}
				>
					<CustomInput
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={`3 ${t("common:level").toLowerCase()}`}
					name="code3"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^\d{1,2}$/
						}
					]}
				>
					<CustomInput
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={`4 ${t("common:level").toLowerCase()}`}
					name="code4"
					rules={[
						{
							required   : true,
							whitespace : true,
							message    : t('valid:codeFilledBad'),
							pattern    : /^\d{1,2}$/
						}
					]}
				>
					<CustomInput
						placeholder={`${t('action:enter')} ${t('common:code').toLowerCase()}`}
					/>
				</Form.Item>
				<Form.Item
					label={t('common:title')}
					name="name"
					rules={[
						{
							required   : true,
							whitespace : true,
							min        : 3,
							max        : 200
						}
					]}
				>
					<CustomInput
						maxLength={ 250 }
						placeholder={`${t('action:enter')} ${t('common:title').toLowerCase()}`}
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ReObjectFunctionTypeChangeForm
